import { render } from "./create-journal.vue?vue&type=template&id=d8a07aa8&scoped=true"
import script from "./create-journal.vue?vue&type=script&lang=js"
export * from "./create-journal.vue?vue&type=script&lang=js"

import "./create-journal.vue?vue&type=style&index=0&id=d8a07aa8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8a07aa8"]])

export default __exports__